'use client';

import { brand } from '@lib/config/brand';
import { cn } from '@lib/util/cn';
import LocalizedClientLink from '@modules/common/components/localized-client-link';
import { Phone, User } from '@modules/common/icons';

type FooterActionsProps = {
  onClose: () => void;
};

const linkClassName = 'flex items-center gap-3 px-4 text-white';

const FooterActions = ({ onClose }: FooterActionsProps) => (
  <div
    className="bg-brand-primary-700 shrink-0"
    style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
  >
    <LocalizedClientLink
      href="/account"
      onClick={onClose}
      className={cn(linkClassName, 'pb-2.5 pt-[22px]')}
    >
      <User size="20" aria-hidden="true" />
      Log in / Create account
    </LocalizedClientLink>
    {brand.telephone && (
      <a
        href={`tel:${brand.telephone}`}
        aria-label={`Call us on ${brand.telephone}`}
        className={cn(linkClassName, 'pt-2.5 pb-[22px]')}
      >
        <Phone size="20" aria-hidden="true" />
        Need help? Contact us
      </a>
    )}
  </div>
);

export default FooterActions;
